import type { FormServerErrors } from './Form';

export interface ErrorSummaryItem {
  field: string;
  message: string;
}

export function readErrorSummaryItems(value: unknown, prefix = ''): ErrorSummaryItem[] {
  if (typeof value !== 'object' || value === null) return [];

  const record = Object.entries(value);
  const items: ErrorSummaryItem[] = [];
  for (const [key, nestedValue] of record) {
    const field = prefix ? `${prefix}.${key}` : key;
    if (typeof nestedValue !== 'object' || nestedValue === null) continue;
    if ('message' in nestedValue && typeof nestedValue.message === 'string') {
      items.push({ field, message: nestedValue.message });
      continue;
    }
    items.push(...readErrorSummaryItems(nestedValue, field));
  }
  return items;
}

export function readServerErrorSummaryItems(serverErrors: FormServerErrors | undefined): ErrorSummaryItem[] {
  return Object.entries(serverErrors ?? {}).flatMap(([field, messages]) =>
    messages.map(message => ({ field, message })),
  );
}

export function focusFormField(field: string): void {
  const candidates = [
    ...document.querySelectorAll<HTMLElement>(`[name="${CSS.escape(field)}"]`),
    ...document.querySelectorAll<HTMLElement>(`[data-form-field-name="${CSS.escape(field)}"]`),
    ...document.querySelectorAll<HTMLElement>(`[name^="${CSS.escape(`${field}.`)}"]`),
    ...document.querySelectorAll<HTMLElement>(`[data-form-field-name^="${CSS.escape(`${field}.`)}"]`),
  ];
  const element = candidates.find(candidate => candidate.getClientRects().length > 0) ?? candidates[0];
  if (element instanceof HTMLElement) element.focus();
}
